import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useDispatch } from "react-redux";
import {
  LogoutOutlined,
  DashboardOutlined,
  EventAvailableOutlined,
  PlaceOutlined,
} from '@mui/icons-material';
import { GroupedMenu } from "../Sidebar";
import { Logout, reset } from "../../fitur/AuthSlice";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import Button from "@mui/material/Button";


// Urutan dari yang paling sering dipakai; menu dengan satu halaman tampil sebagai link biasa.
const PRESENSI_MENU = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: <DashboardOutlined fontSize="small" />,
    items: [{ label: 'Dashboard', to: '/dashboard' }],
  },
  {
    key: 'presensi',
    label: 'Presensi',
    icon: <EventAvailableOutlined fontSize="small" />,
    items: [
      { label: 'Dashboard Presensi', to: '/presensi', fitur: 'presensi' },
      { label: 'Data Presensi', to: '/datapresensi', fitur: 'presensi' },
      { label: 'Presensi Manual', to: '/presensimanual', fitur: 'presensi' },
      { label: 'Data Bulanan', to: '/datapresensibulan', fitur: 'presensi' },
      { label: 'Rekap Presensi', to: '/rekappresensi', fitur: 'presensi' },
    ],
  },
  {
    key: 'lokasi',
    label: 'Lokasi Presensi',
    icon: <PlaceOutlined fontSize="small" />,
    items: [{ label: 'Lokasi Presensi', to: '/lokasipresensi', fitur: 'presensi' }],
  },
];

export const SidebarPresensi = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleLogoutClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setOpenConfirmDialog(true);
  };

  const handleConfirmLogout = () => {
    dispatch(Logout());
    dispatch(reset());
    navigate("/");
    setOpenConfirmDialog(false);
  };

  const handleCancelLogout = () => {
    setOpenConfirmDialog(false);
  };

  return (
    <Box
      sx={{
        bgcolor: '#1e293b',
        color: 'white',
        display: { xs: 'block', lg: 'flex' },
        flexDirection: 'column',
        height: '100vh',
        width: { xs: 200, lg: 250 },
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1200,
        overflow: 'auto', // Hide overflow for parent container
      }}
    >
      <Dialog
        open={openConfirmDialog}
        onClose={handleCancelLogout}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Konfirmasi Keluar
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Apakah Anda yakin ingin keluar dari sistem?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelLogout} color="primary">
            Batal
          </Button>
          <Button 
            onClick={handleConfirmLogout} 
            color="error"
            autoFocus
            startIcon={<LogoutOutlined />}
          >
            Ya, Keluar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Logo Section - Fixed at top */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 60,
          p: 2,
          borderBottom: '1px solid #374151',
          position: 'sticky',
          top: 0,
          bgcolor: '#1e293b',
          zIndex: 2,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          Juragan Kuliner
        </Typography>
      </Box>

      {/* Scrollable Navigation Links */}
      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          height: 'calc(100vh - 120px)', // Viewport height minus header and footer space
          p: 2,
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#1e293b',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#374151',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#4b5563',
          },
          scrollbarWidth: 'thin',
          scrollbarColor: '#374151 #1e293b',
        }}
      >
        <GroupedMenu menu={PRESENSI_MENU} />
      </Box>

      {/* Footer with Logout Button - Fixed at bottom */}
      <Box
        sx={{
          p: 2,
          borderTop: '1px solid #374151',
          position: 'sticky',
          bottom: 0,
          bgcolor: '#1e293b',
          zIndex: 2,
        }}
      >
        <Button
          onClick={handleLogoutClick}
          sx={{
            width: "100%",
            justifyContent: "flex-start",
            color: "#cbd5e1",
            p: 1.5,
            borderRadius: 1,
            textTransform: "none",
            transition: "all 0.3s ease",
            "&:hover": {
              bgcolor: "#EF4444",
              color: "white",
              transform: "scale(1.05)", 
            },
            minHeight: "48px",
            touchAction: "manipulation",
          }}
          startIcon={<LogoutOutlined />}
        >
          Keluar
        </Button>
      </Box>
    </Box>
  );
};

export default SidebarPresensi;